export default (entry, data, callback) => () => {
  callback(entry, data);
};
